// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"c83d273f","344":"a046306d","397":"5d71e4fd","409":"b0653f62","418":"ea2ca353","463":"4f0e89d4","543":"6938ccf2","710":"bdac89fc","711":"fabc1f83","918":"6bc62bba"}[chunkId] + ".chunk.js";
};